export default "__VITE_ASSET__B$b7mmEa__"